define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_LINE_WIDTH_PERCENTAGE = 40;
    const DEFAULT_LINE_HEIGHT_PERCENTAGE = 5;

    /**
     * Model for a line widget.
     *
     * @class LineWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Line widget", {
        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "line",
            width: DEFAULT_LINE_WIDTH_PERCENTAGE,
            height: DEFAULT_LINE_HEIGHT_PERCENTAGE,
            backgroundColor: "transparent",
            lineColor: "#000000",
            lineHeight: 2 // Pixels
        }),

        isValid() {
            // We need a shadow color or background color to represent the line widget
            return this.get("width") > 0 && this.get("height") > 0;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/lineWidget/LineWidgetModel.js